@if (label()) { <span class="label">{{ label() }}</span> }

<section class="files">
  @for (input of fileInputs(); track input.originalName; let index = $index) {
    <mat-form-field appearance="outline" [class.exceeds-max-size]="exceedsMaxSize(input.file)">
      <mat-icon matPrefix>file_present</mat-icon>
      <input matInput [ngModel]="input.file.name" #name="ngModel" required (blur)="updateFileName(index, name.value)" />
      <button mat-icon-button matSuffix type="button" (click)="removeFile(index)">
        <mat-icon>delete</mat-icon>
      </button>
      <mat-hint>{{ input.originalName }}</mat-hint>
      <mat-error *r2eValidationError="let errorMessage from name.errors">{{ errorMessage }}</mat-error>
    </mat-form-field>
  }
</section>

<input #fileInput [accept]="accept()" [multiple]="multiple()" type="file" (change)="selectFiles($event)" (click)="onTouched?.()" />

<section class="actions">
  <button mat-stroked-button type="button" (click)="fileInput.click()">
    <mat-icon>attach_file</mat-icon>
    @if (fileInputs().length > 0 && multiple()) {
      {{ 'COMMON.ACTIONS.ADD_FILES' | translate }}
    } @else {
      @if (multiple()) {
        {{ 'COMMON.ACTIONS.CHOOSE_FILES' | translate }}
      } @else {
        {{ 'COMMON.ACTIONS.CHOOSE_FILE' | translate }}
      }
    }
  </button>

  <ng-content select="button" />
</section>

<section class="subscript">
  @if (ivalid) {
    <mat-error *r2eValidationError="let err from errors">{{ err }}</mat-error>
  } @else if (hint()) {
    <mat-hint>{{ hint() }}</mat-hint>
  } @else if (maxSize()) {
    <mat-hint>{{ 'COMMON.HINTS.MAX_FILE_SIZE' | translate: { maxSize: maxSize()! } }}</mat-hint>
  }
</section>
